export default __webpack_public_path__ + "static/media/iqvia_core.1bc6ad52.svg";